export type ViewStyleNamesType =
  | 'view_style_home'
  | 'view_style_channel'
  | 'view_style_downloads'
  | 'view_style_playlist';
export const ViewStyleNames = {
  Home: 'view_style_home',
  Channel: 'view_style_channel',
  Downloads: 'view_style_downloads',
  Playlist: 'view_style_playlist',
};

export type ViewStylesType = 'grid' | 'list' | 'table';
export const ViewStylesEnum = {
  Grid: 'grid',
  List: 'list',
  Table: 'table',
};
